export const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export const LOCATIONS = [
  'Room 1 - Black', 'Room 2 - Green', 'Room 3 - Blue', 'Room 4 - Yellow',
  'Room 6 - Purple', 'Room 7 - Maroon', 'Room 8 - Red', 'Zoom Lesson 1',
]

export const LESSON_LOCATION_OPTIONS = [
  'Room 1', 'Room 2', 'Room 3', 'Room 4', 'Room 5', 'Room 6', 'Room 7', 'Room 8',
  'Remote', 'Other',
]
